import React, { useEffect } from "react";
import { addToCart, removeFromCart } from "../../store/actions/cartActions";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MessageBox from "../../Components/MessageBox";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./index.css";

function CartScreen(props) {
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = useParams();
  const { id: productId } = params;

  const qtyInUrl = new URLSearchParams(search).get("qty");
  const qty = qtyInUrl ? Number(qtyInUrl) : 1;

  const dispatch = useDispatch();

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    navigate("/signin?redirect=/shipping");
  };

  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, qty));
    }
  }, [dispatch, productId, qty]);
  return (
    <div>
      <div className="imageOverlayContainer">
        <h1>Cart</h1>
        <div className="colorOverlay"></div>
      </div>
      <div className="mt-5">
        <Container>
          <Row>
            <Col md={12}>
              {cartItems.length === 0 ? (
                <MessageBox>
                  Cart is empty. <Link to="/">Go Shopping</Link>
                </MessageBox>
              ) : (
                <>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableBody>
                        {cartItems.map((row, i) => (
                          <TableRow key={i}>
                            <TableCell>
                              <img
                                width="100px"
                                src={row.image.map((img, i) => img.coverimg)}
                                alt="img"
                              />
                            </TableCell>
                            <TableCell className="text-primary">
                              {row.name}
                            </TableCell>
                            <TableCell align="right">
                              <Box sx={{ minWidth: 100 }}>
                                <FormControl>
                                  <InputLabel id="demo-simple-select-label">
                                    Qty
                                  </InputLabel>
                                  <Select
                                    labelId="simple-select-label"
                                    id="simple-select"
                                    label="Quantity"
                                    value={row.qty}
                                    onChange={(e) =>
                                      dispatch(
                                        addToCart(
                                          row.product,
                                          Number(e.target.value)
                                        )
                                      )
                                    }
                                  >
                                    {[...Array(row.countInStock).keys()].map(
                                      (x) => (
                                        <MenuItem key={x + 1} value={x + 1}>
                                          {x + 1}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                </FormControl>
                              </Box>
                            </TableCell>
                            <TableCell align="right">{`${row.price + " $"
                              }`}</TableCell>
                            <TableCell align="right">
                              <Button
                                variant="outline-danger"
                                onClick={() =>
                                  removeFromCartHandler(row.product)
                                }
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Col>
          </Row>

          <Row className="py-5 cartStyle">
            <Col md={6}>
              <Card style={{ width: "18rem" }}>
                <Card.Body>
                  <Card.Title>
                    Subtotal ({cartItems.reduce((a, c) => a + c.qty, 0)} items)
                    : $
                    {cartItems.reduce(
                      (a, c) => a + parseInt(c.price) * c.qty,
                      0
                    )}
                  </Card.Title>
                  <Button
                    className="w-100 text-center"
                    onClick={checkoutHandler}
                    variant="primary"
                    disabled={cartItems.length === 0}
                  >
                    Proceed to Checkout
                  </Button>
                </Card.Body>
                <Card.Footer style={{ border: 'none', backgroundColor: 'transparent' }}>
                  <Link to="/" className="tdnone">
                    <h5 style={{ fontSize: '15px', fontStyle: 'italic' }} className="text-info">Add more Products</h5>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default CartScreen;
